import { REFERRAL_ACTION } from '../../constants/actions'

const getInvites = () => ({
  type: REFERRAL_ACTION.GET_INVITES
})

export { getInvites }
